import React, { useContext, useEffect, useMemo, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import userContext from "../../context/users/UserContext";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { t } from "i18next";

import "../ListViewV2/ListViewStylesV2.css";
import PageHeader from "../PageHeader";
import {
  QueryClient,
  QueryClientProvider,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import themeContext from "../../context/theme/ThemeContext";
import SortFilterSection from "../ListViewV2/SortFilterSection";
import ListViewTableV3 from "./ListViewTableV3";
import SortPopupFilterSectionV2 from "./SortPopupFilterSectionV2";
import ListViewTableV2 from "../ListViewV2/ListViewTableV2";
import CustomBreadCrumb from "../CustomBreadCrumb";
const queryClient = new QueryClient();

const ListViewV3 = (props) => {
  const placeholder =
    props.placeholder == undefined || props.placeholder == null
      ? t("user.username")
      : props.placeholder;
  const headerPagePresent =
    props.heading == undefined || props.heading == null ? false : true;
  const extraMargin = props.extraMargin != undefined && props.extraMargin != null ? props.extraMargin : true;
  const { themeName } = useContext(themeContext);
  const showFilter =
    props.showFilter == undefined || props.showFilter == null
      ? true
      : props.showFilter;

  const constantFilterHeight =
    props.showFilter == undefined || props.showFilter == null ? false : true;
    const showSideBySide = props.showSideBySide != undefined && props.showSideBySide != null ? props.showSideBySide : false;
    const fullLength = props.fullLength != undefined && props.fullLength != null ? props.fullLength : false;
    const tabHeaderPresent = props.tabHeaderPresent !== undefined && props.tabHeaderPresent !== null ? props.tabHeaderPresent : false;
    const showPagination = props.showPagination !== undefined && props.showPagination !== null ? props.showPagination : true;
    const fullLengthForRow = props.fullLengthForRow != undefined && props.fullLengthForRow != null ? props.fullLengthForRow : fullLength;
    const [dataQueryStateManual, setDataQueryStateManual] = useState({});
    const [listViewLoading, setListViewLoading] = useState(false);
    const listViewRef = useRef(null);
    return (
    <>
      <div className="main-container-body-list-view react-scroll">
        {headerPagePresent && (
          <div className="breadCrumb">
              <CustomBreadCrumb 
              headerPagePresent= {!headerPagePresent}
              alignmentHeading = {extraMargin}
              items={[{
                text: props.heading,
                key: props.heading,
            }]
          } />
            </div>
          // <div className="list-view-page-header">
          //   <span className="list-view-page-header-text">{props.heading}</span>
          // </div>
        )}
        {showFilter &&
          (
            <SortPopupFilterSectionV2
              sortObj={props.sortObj}
              filterObj={props.filterObj}
              setSortObj={props.setSortObj}
              setFilterObj={props.setFilterObj}
              buttonsTopBar={props.buttonsTopBar}
              sortDropdownOptions={props.sortDropdownOptions}
              setPagination={props.setPagination}
              paginationObj={props.paginationObj}
              placeholder={placeholder}
              handleApplyClick={props.handleApplyClick}
              displayListAppliedFilter={props.displayListAppliedFilter}
              filterPopUpComponent={props.filterPopUpComponent}
              handleClearFilter={props.handleClearFilter}
              removeBadgeFromFilter={props.removeBadgeFromFilter}
              showSearch={props.showSearch}
              showSort={props.showSort}
              enhancedFilter={props.enhancedFilter}
              handlePopupClose={props.handlePopupClose}
            />
          )}

        {constantFilterHeight && tabHeaderPresent && (
          <span
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div className="empty-filter-section"></div>
            {(props.buttonsTopBar != undefined && props.buttonsTopBar.length > 0) && (
              <div style={{ display: "flex", marginRight: "25px" }}>
                {props.buttonsTopBar.map((ele, index) => {
                  return <React.Fragment key={index}>{ele.button}</React.Fragment>
                })}
              </div>
            )}
          </span>
        )}

        <QueryClientProvider client={queryClient}>
          {/* <ListViewTable
                updateCurrentPage={props.updateCurrentPage}
                cacheTime={200}
                fetchFunction={props.fetchDataFunction}
                columns={props.columns}
                filterObj={props.filterObj}
                initialState={{}}
                sortObj={sortObj}
                setSelectedRowObj={props.setSelectedRowObj}
                selectedRowObj={props.selectedRowObj}
                sideBarComponent = {props.sideBarComponent}
                handleUserClick = {props.handleUserClick}
                widthContainer = {props.widthContainer == null || props.widthContainer == undefined ? 
                  "100%": props.widthContainer}
              /> */}

          { <ListViewTableV3
            fetchData={props.fetchData}
            columns={props.columns}
            sortObj={props.sortObj}
            filterObj={props.filterObj}
            showSideBySide={showSideBySide}
            setPagination={props.setPagination}
            pageIndex={props.paginationObj.pageIndex}
            pageSize={props.paginationObj.pageSize}
            pageIndexFromParent={props.paginationObj.pageIndex}
            handleUserClick={props.handleUserClick}
            uniqueKey={props.uniqueKey}
            selectedRow={props.selectedRow}
            selectedRowComponent={props.selectedRowComponent}
            setActiveDataQuery={props.setActiveDataQuery}
            showHeader={props.showHeader}
            fullLength={fullLength}
            tabHeaderPresent={tabHeaderPresent}
            showPagination={showPagination}
            pointer={props.pointer}
            fullLengthForRow={fullLengthForRow}
            dataQueryState={(props.dataQueryState != null && props.dataQueryState != undefined) ? props.dataQueryState : dataQueryStateManual}
            setDataQueryState={(props.setDataQueryState != null && props.setDataQueryState != undefined) ? props.setDataQueryState : setDataQueryStateManual}
            listViewLoading={(props.listViewLoading != null && props.listViewLoading != undefined) ? props.listViewLoading : listViewLoading}
            listViewRef={(props.listViewLoading != null && props.listViewLoading != undefined) ? props.listViewRef : listViewRef }
            setListViewLoading = {(props.setListViewLoading != null && props.setListViewLoading != undefined) ? props.setListViewLoading : setListViewLoading }
          />}

          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </div>
    </>
  );
};

export default ListViewV3;
